// extracted by mini-css-extract-plugin
export default {"search":"XUn4KG8Lccuvv5NooDW4","searchMobile":"wQPjH7ZceIUJ0uqoXmnN","searchIcon":"lMXUGPTBZ15rQ8cD_UWR","optionLabel":"jSDjfePp4jly9Ef2D2ru"};